// extracted by mini-css-extract-plugin
module.exports = {"badge":"BetaBadge-module__badge___1PM6c"};